"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
let EscapeSequenceEncoder = class EscapeSequenceEncoder {
    constructor() {
        this.stringsCache = new Map();
    }
    encode(string, encodeAllSymbols) {
        const cacheKey = `${string}-${String(encodeAllSymbols)}`;
        if (this.stringsCache.has(cacheKey)) {
            return this.stringsCache.get(cacheKey);
        }
        const radix = 16;
        const replaceRegExp = new RegExp('[\\s\\S]', 'g');
        const escapeSequenceRegExp = new RegExp('[\'\"\\\\\\s]');
        const regExp = new RegExp('[\\x00-\\x7F]');
        let prefix;
        let template;
        const result = string.replace(replaceRegExp, (character) => {
            if (!encodeAllSymbols && !escapeSequenceRegExp.exec(character)) {
                return character;
            }
            if (regExp.exec(character)) {
                prefix = '\\x';
                template = '00';
            }
            else {
                prefix = '\\u';
                template = '0000';
            }
            return `${prefix}${(template + character.charCodeAt(0).toString(radix)).slice(-template.length)}`;
        });
        this.stringsCache.set(cacheKey, result);
        this.stringsCache.set(`${result}-${String(encodeAllSymbols)}`, result);
        return result;
    }
};
EscapeSequenceEncoder = __decorate([
    inversify_1.injectable()
], EscapeSequenceEncoder);
exports.EscapeSequenceEncoder = EscapeSequenceEncoder;
